import Pia from '../pia/type';

export const fundFullFloatKeys: (keyof Pia.FundsRows)[] = [
  'estimated_co2_scope_1_2_per_m2',
  'estimated_energy_intensity',
  'computed_pe_ratio', // Is mark as % in excel but is float
  'computed_gav_after_distribution',
  'computed_nav_after_distribution',
  'computed_gav_compounded',
  'computed_nav_compounded',
  'market_beta',
  'market_share_price',
  'market_fifty_two_weeks_high',
  'market_fifty_two_weeks_low',
  'market_high',
  'market_last',
  'market_low',
  'market_open',
  'reported_share_price',
  'market_turnover',
  'reported_total_dividend',
  'reported_dividend_from_capital_gains',
  'reported_dividend_from_direct_rental_income',
  'reported_dividend_from_indirect_rental_income',
  'reported_gav_before_distribution',
  'reported_nav_before_distribution',

  'computed_total_cash_per_share',
  'computed_earnings_per_share',
  'computed_revenue_per_share',
  'market_dividend',
  'market_r2',
  'computed_median_maturity',
  'computed_weighted_average_maturity',
  'reported_wault',

  'market_hist_volatility_250_days',
  'market_hist_volatility_180_days',
  'market_hist_volatility_90_days',
  'market_hist_volatility_30_days',
  'market_implied_volatility',
  'reported_co2_per_m2',
  'reported_energy_intensity',
];

export default fundFullFloatKeys;
